// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-center[data-v-fd07fa08] {\n  text-align: center;\n}\n.justify-center[data-v-fd07fa08] {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  /* Adds space between buttons */\n}\n.btn-large[data-v-fd07fa08] {\n  font-size: 18px;\n  padding: 12px 24px;\n}\n", ""]);
// Exports
module.exports = exports;
